<template>
  <div id="brmHomepage" class="page-content">
    <div style="margin: -40px 0px 0px 0px;">
      <el-row>
        <el-col :span="18" style="margin-bottom: 20px;padding-right: 20px;">
          <div class="titlefont">
            <div class="iconDiv">
              .
            </div>
            BRM业务
          </div>
          <el-card class="box-card" style="margin-top: 20px;">
            <el-row>
              <el-col :span="8">
                <div class="bigIg">
                  <div class="imgbor">
                    <img :src='require("@/assets/img/service.png")' class="imgicon">
                  </div>
                  <div class="fontNum">
                    {{brmcount}}
                  </div>
                  <br>
                  <div class="fontsty">
                    品牌方总数量
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="bigIg">
                  <div class="imgbor">
                    <img :src='require("@/assets/img/Trader.png")' class="imgicon">
                  </div>
                  <div class="fontNum">
                    {{dealerSum}}
                  </div>
                  <br>
                  <div class="fontsty">
                    经销商总数量
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="bigIg">
                  <div class="imgbor">
                    <img :src='require("@/assets/img/Shop.png")' class="imgicon">
                  </div>
                  <div class="fontNum">
                    {{shopSum}}
                  </div>
                  <br>
                  <div class="fontsty">
                    店铺总数量
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="6" style="margin-bottom: 20px;">
          <div class="titlefont">
            <div class="iconDiv">
              .
            </div>
            IPR业务
          </div>
          <el-card class="box-card" style="margin-top: 20px;">
            <div class="bigIg">
              <div class="imgbor">
                <img :src='require("@/assets/img/Brand.png")' class="imgicon">
              </div>
              <div class="fontNum">
                {{iprcount}}
              </div>
              <br>
              <div class="fontsty">
                服务客户数量
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18" style="margin-bottom: 20px;padding-right: 20px;">
          <div class="titlefont">
            <div class="iconDiv">
              .
            </div>
            BRM业务数据概况
          </div>
          <el-card class="box-card" style="margin-top: 20px;">
            <el-row>
              <el-col :span="8">
                <div class="bigIg">
                  <div class="imgbor">
                    <img :src='require("@/assets/img/Commodity library.png")' class="imgicon">
                  </div>
                  <div class="fontNum">
                    {{itemListSum}}
                  </div>
                  <br>
                  <div class="fontsty">
                    商品库商品数量
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="bigIg">
                  <div class="imgbor">
                    <img :src='require("@/assets/img/product.png")' class="imgicon">
                  </div>
                  <div class="fontNum">
                    {{productSum}}
                  </div>
                  <br>
                  <div class="fontsty">
                    客户产品总数量
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="bigIg">
                  <div class="imgbor">
                    <img :src='require("@/assets/img/Single link query.png")' class="imgicon">
                  </div>
                  <div class="fontNum">
                    {{linkDataSum}}
                  </div>
                  <br>
                  <div class="fontsty">
                    监控单链接个数
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="6" style="margin-bottom: 20px;">
          <div class="titlefont">
            <div class="iconDiv">
              .
            </div>
            系统反馈
          </div>
          <el-card style="margin-top: 20px;height: 130px;text-align: center;line-height: 94px;">
            待处理反馈数：<span style="font-size: 30px;color: #e90e24;">{{workOrderSum}}</span>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- 二维码 -->
    <!-- <el-dialog :visible.sync="dialogVisible" width="409px">
      <div style="text-align: center;">
        <img :src='require("@/assets/img/qrcode.jpg")' style="width: 197px;height: 197px;">
        <div style="font-size: 18px;color: #333333;margin-top: -13px;">关注微信公众号，绑定微信</div>
        <div style="font-size: 14px;color: #999999;margin-top: 41px;">关注微信公众号，绑定微信后:</div>
        <div style="font-size: 14px;color: #999999;margin-top: 12px;">1、可在移动端中查看业务消息，处理业务事项。</div>
        <div style="font-size: 14px;color: #999999;text-align: left;margin-left: 33px;">2、登录时可以使用微信扫码登录。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" size="small">我知道了</el-button>
      </span>
    </el-dialog> -->
    <!-- 二维码 -->
  </div>
</template>

<script>
  import pagination from "../../components/dataTable/pagination";
  export default {
    data() {
      return {
        brmcount: '',
        dealerSum: '',
        shopSum: '',
        productSum: '',
        itemListSum: '',
        linkDataSum: '',
        iprcount: '',
        workOrderSum: '',
        wechatUrl: '',
        // dialogVisible: false,
      }
    },
    mounted() {
      this.type = JSON.parse(window.localStorage.userData)
      console.log(this.type.logintype)
      this.theQuery()
    },
    methods: {
      theQuery() {

        fetch({
          url: "hcm/Index/adminIndex",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.brmcount = data.brmcount
            this.dealerSum = data.dealerSum
            this.shopSum = data.shopSum
            this.productSum = data.productSum
            this.itemListSum = data.itemListSum
            this.linkDataSum = data.linkDataSum
            this.iprcount = data.iprcount
            this.workOrderSum = data.workOrderSum
            this.linkDataSum = data.linkDataSum
            // if (data.binding) {
            //   this.dialogVisible = false
            // } else {
            //   this.dialogVisible = true
            // }
          } else if (res.status == '10400') {

          }
        })
      },
    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .el-card, .el-message {
    border-radius: 16px;
    overflow: hidden;
  }
  .iconDiv {
    width: 5px;
    background-color: #333333;
    margin-right: 10px;
    height: 21px;
    margin-top: 4px;
  }
  .imgbor {
    border: 1px solid #e8e2d7;
    width: 48px;
    height: 48px;
    border-radius: 5px;
    float: left;
  }
  .bigIg {
    margin: 20px 0px 40px 20px;
    height: 48px;
    float: left;
    width: 100%;
  }
  .imgicon {
    margin: 10px;
    width: 26px;
    height: 30px;
  }
  .fontsty {
    float: left;
    margin-left: 17px;
    margin-top: 7px;
  }
  .fontNum {
    float: left;
    margin-left: 17px;
  }
  .titlefont {
    font-size: 18px;
    color: #333333;
    display: flex;
  }
</style>
<style lang="scss">
#brmHomepage {
  .el-dialog__header {
    border-bottom: none;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-card__body {
    padding: 20px 20px 0px 20px;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
}
</style>
